export interface FlipCoinPlayer {
  userAddress: string;
  userName: string;
  userAvatarUrl: string;
  seasonPoints?: number;
}

export enum GameStatus {
  PENDING = 'PENDING',
  STARTED = 'STARTED',
  COMPLETED = 'COMPLETED',
  CANCELED = 'CANCELED',
  INITIAL = 'INITIAL'
}

export const enum PlayerButtonState {
  WIN = 'win',
  LOSE = 'lose'
}

export type TPlayerButtonState = PlayerButtonState.WIN | PlayerButtonState.LOSE;

export interface FlipCoinGame {
  gameId: number;
  ownerPlayer: FlipCoinPlayer;
  joinerPlayer: FlipCoinPlayer;
  isOddBet: boolean;
  betAmount: string;
  winAmount: string;
  tokenAddress: string;
  winner: string;
  status: GameStatus;
  createdAt: string;
  closedAt: string;
}

export interface StartGameDTO {
  isOdd: boolean;
  token: string;
  playAmount: number;
}

export type GetPageOfGamesParams = {
  sort: string;
  limit?: number;
  offset?: number;
  userAddress?: string;
};

export enum FlipCoinTabs {
  SelectGame,
  Bets,
  SelectToken,
  BetSelection,
  Game,
  Result,
  Winners,
  Info
}
